import { create } from 'zustand'
import { Task } from '../Pages/Tasks_new/types'

type TasksStore = {
	tasks: Task[]
	setTasks: (arg: any[]) => void
	isLoading: boolean
	setIsLoading: (loading: boolean) => void
	showNotification: boolean
	setShowNotification: (show: boolean) => void
	triggerNotification: (isModalOpen?: boolean) => void
	refreshSponsorsTasks: () => void
	setRefreshSponsorsTasks: (callback: () => void) => void
	notificationTimer: NodeJS.Timeout | null
	setNotificationTimer: (timer: NodeJS.Timeout | null) => void
	clearNotificationTimer: () => void
	delayedNotification: boolean
	setDelayedNotification: (delayed: boolean) => void
	showDelayedNotification: () => void
	lastSponsorsFetchTime: number
	setLastSponsorsFetchTime: (time: number) => void
	canRefreshSponsors: () => boolean
	// Состояние таймера кнопки обновления
	isRefreshing: boolean
	setIsRefreshing: (refreshing: boolean) => void
	timeLeft: number
	setTimeLeft: (time: number) => void
	startRefreshTimer: () => void
	stopRefreshTimer: () => void
	// Флаг для контроля fetch после перезагрузки
	needInitialFetch: boolean
	setNeedInitialFetch: (need: boolean) => void
	refreshSponsorsTasksCallback: (() => void) | undefined
}

export const useTasksStore = create<TasksStore>((set, get) => ({
	tasks: [],
	setTasks: arg => set({ tasks: arg }),
	isLoading: false,
	setIsLoading: loading => set({ isLoading: loading }),
	showNotification: false,
	setShowNotification: show => set({ showNotification: show }),
	notificationTimer: null,
	setNotificationTimer: timer => set({ notificationTimer: timer }),
	clearNotificationTimer: () => {
		const state = get()
		if (state.notificationTimer) {
			clearTimeout(state.notificationTimer)
			set({ notificationTimer: null })
		}
	},
	delayedNotification: false,
	setDelayedNotification: delayed => set({ delayedNotification: delayed }),
	showDelayedNotification: () => {
		const state = get()
		if (state.delayedNotification) {
			set({
				showNotification: true,
				delayedNotification: false,
			})

			// Автоматически скрываем уведомление через 5 секунд
			const timer = setTimeout(() => {
				set({ showNotification: false })
			}, 5000)

			set({ notificationTimer: timer })
		}
	},
	triggerNotification: (isModalOpen = false) => {
		const state = get()

		if (isModalOpen) {
			set({ delayedNotification: true })
		} else {
			set({ showNotification: true })

			// Автоматически скрываем уведомление через 5 секунд
			const timer = setTimeout(() => {
				set({ showNotification: false })
			}, 5000)

			set({ notificationTimer: timer })
		}
	},
	refreshSponsorsTasksCallback: undefined,
	refreshSponsorsTasks: () => {
		const state = get()
		if (state.refreshSponsorsTasksCallback) {
			state.refreshSponsorsTasksCallback()
		}
	},
	setRefreshSponsorsTasks: callback => set({ refreshSponsorsTasksCallback: callback }),
	lastSponsorsFetchTime: 0,
	setLastSponsorsFetchTime: time => set({ lastSponsorsFetchTime: time }),
	canRefreshSponsors: () => {
		const state = get()
		const timeSinceLastFetch = Date.now() - state.lastSponsorsFetchTime
		const FETCH_COOLDOWN = 60000 // 60 секунд кулдаун (соответствует автоматическому интервалу)
		return timeSinceLastFetch >= FETCH_COOLDOWN
	},
	// Состояние таймера кнопки обновления
	isRefreshing: false,
	setIsRefreshing: refreshing => set({ isRefreshing: refreshing }),
	timeLeft: 0,
	setTimeLeft: time => set({ timeLeft: time }),
	startRefreshTimer: () => {
		const state = get()
		if (state.isRefreshing) return // Уже запущен

		set({ isRefreshing: true, timeLeft: 30 })
		const timer = setInterval(() => {
			const currentState = get()
			if (currentState.timeLeft <= 1) {
				clearInterval(timer)
				set({ isRefreshing: false, timeLeft: 0 })
			} else {
				set({ timeLeft: currentState.timeLeft - 1 })
			}
		}, 1000)
	},
	stopRefreshTimer: () => {
		set({ isRefreshing: false, timeLeft: 0 })
	},
	// Флаг для контроля fetch после перезагрузки
	needInitialFetch: false,
	setNeedInitialFetch: need => set({ needInitialFetch: need }),
}))
